import { render, staticRenderFns } from "./PurchaseSuccess.vue?vue&type=template&id=9f4ed866&scoped=true&"
import script from "./PurchaseSuccess.vue?vue&type=script&lang=js&"
export * from "./PurchaseSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f4ed866",
  null
  
)

export default component.exports